/**
 * @generated SignedSource<<31c94382d9625fbf30147f3f8ca1ab3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SectionCompanyKnown_referral$data = {
  readonly company: {
    readonly displayName: string;
    readonly thumbnailUrl: string;
  } | null;
  readonly " $fragmentType": "SectionCompanyKnown_referral";
};
export type SectionCompanyKnown_referral$key = {
  readonly " $data"?: SectionCompanyKnown_referral$data;
  readonly " $fragmentSpreads": FragmentRefs<"SectionCompanyKnown_referral">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SectionCompanyKnown_referral",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyNode",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbnailUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OptionalCompanyInterface",
  "abstractKey": "__isOptionalCompanyInterface"
};

(node as any).hash = "73a1bb7d91f964bc1026a3e13486100a";

export default node;
